<input #colorPicker type="color" [value]="strValue" (change)="colorChanged(colorPicker.value)" />